import {
	Alert,
	AlertDescription,
	AlertTitle,
} from '@dealstack/frontend/shared/components/Alert/Alert';
import { memo } from 'react';
import styled from 'styled-components';
import { IAlertProps } from '@dealstack/frontend/shared/components/Alert/Alert.types';

interface ConfirmationModalContent {
	className?: string;
	title: string;
	description: React.ReactNode;
	children?: React.ReactNode;
	state?: IAlertProps['state'];
}

const ConfirmationModalContent = ({
	className,
	title,
	description,
	children,
	state = 'success',
}: ConfirmationModalContent) => {
	return (
		<Alert icon="tick-circle-filled" state={state} size="m" className={className}>
			<AlertTitle>{title}</AlertTitle>
			<AlertDescription>{description}</AlertDescription>
			{children}
		</Alert>
	);
};

const Memoized = memo(ConfirmationModalContent);
const Styled = styled(Memoized)`
	${AlertDescription} {
		margin-bottom: 1rem;
	}
`;

export { Styled as ConfirmationModalContent };
